import { observable } from 'mobx';

import { FetchOptions, SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import {
  FlightsCabinClass,
  FlightsQueryState,
  FlightsShoppingPwaFlightInformationResultsLoading,
  FlightsTripType
} from '__generated__/api/types';
import { MetaQueryAdapter, SearchQueryAdapter } from 'stores/adapters';

export class InformationMetaCriteriaStore extends Store {
  @observable public informationCriteria: FlightsShoppingPwaFlightInformationResultsLoading.Variables;
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
  public setCriteriaFromUrl(fetchOptions: FetchOptions) {
    const query = fetchOptions.query;
    const queryMap = new Map<string, string>();
    Object.keys(query).map(params => queryMap.set(params, query[params]));
    const { flightsDetailComponentsCriteria } = this.informationCriteria;

    flightsDetailComponentsCriteria.journeyIdentifier = query.piid;
    queryMap.delete('piid');
    const amount = query.price;
    queryMap.delete('price');
    const currency = query.ccyc;
    queryMap.delete('ccyc');
    const numberOfAdults = query.cadt;
    queryMap.delete('cadt');
    const numberOfSeniors = query.csen;
    queryMap.delete('csen');
    const ages = query.ages;
    queryMap.delete('ages');
    const infantInLap = query.filp;
    queryMap.delete('filp');
    const cabinClass = query.ccls;
    queryMap.delete('ccls');
    const departureDates = query.ddte;
    queryMap.delete('ddte');
    const departureCities = query.dcty;
    queryMap.delete('dcty');
    const arrivalCities = query.acty;
    queryMap.delete('acty');
    const refundability = query.rfft;
    queryMap.delete('rfft');
    const carrier = query.carrier;
    queryMap.delete('carrier');
    const tripType = query.tytr;
    queryMap.delete('tytr');
    queryMap.delete('prevQuery');

    flightsDetailComponentsCriteria.travelerDetails = MetaQueryAdapter.getTravelerDetails(
      numberOfAdults,
      numberOfSeniors,
      ages,
      infantInLap
    );
    flightsDetailComponentsCriteria.flightsSearchContext = {
      tripType: SearchQueryAdapter.mapTripType(tripType)
    };

    flightsDetailComponentsCriteria.journeyCriteria = MetaQueryAdapter.getFlightJourneyCriteria(
      departureCities,
      arrivalCities,
      departureDates
    );
    flightsDetailComponentsCriteria.searchPreferences = MetaQueryAdapter.getSearchPreferences(
      carrier,
      cabinClass,
      refundability
    );

    if (amount && currency) {
      flightsDetailComponentsCriteria.originalPrice = {
        amount: parseFloat(amount),
        currency: currency
      };
    }

    for (const [key, value] of queryMap) {
      flightsDetailComponentsCriteria.queryParams.push({
        key: key,
        value: value.toString()
      });
    }
  }
}

InformationMetaCriteriaStore.DEFAULTS = {
  informationCriteria: {
    flightsDetailComponentsCriteria: {
      flightsSearchContext: {
        journeysContinuationId: null,
        previousFlightSelections: null,
        tripType: FlightsTripType.ONE_WAY
      },
      journeyCriteria: [],
      journeyIdentifier: 'test',
      originalPrice: null,
      queryParams: [],
      travelerDetails: [],
      searchPreferences: {
        advancedFilters: null,
        airline: null,
        cabinClass: FlightsCabinClass.COACH
      }
    },
    flightsDetailCriteria: null,
    queryState: FlightsQueryState.LOADING
  }
};
